
import Vue from "vue";

export default Vue.extend({
  created() {
    this.$snotify.config.global = {
      maxOnScreen: 5,
      preventDuplicates: true,
    };
  },

  mounted() {
    if (navigator.appVersion.indexOf("Windows NT 6.2") != -1) {
      document.head.innerHTML +=
        '<link rel="stylesheet" type="text/css" href="pages/css/windows.chrome.fix.css" />';
    }

    (function() {
      // Nickelled script
      // @ts-ignore
      let NickelledLaunchers = (window.NickelledLaunchers =
        // @ts-expect-error NickelledLaunchers is provided by the Nickelled script and is not defined in the types
        NickelledLaunchers || {
          setUser: function(u: any) {
            this.userData = u;
          },
          hide: function() {
            this.setUser({
              appId: "konverge-105902",
              userId: -1,
              subscriptionType: "",
            });
          },
        });

      (function() {
        let s, f;
        s = document.createElement("script");
        s.async = true;
        s.src = "https://cdn.nickelled.com/launchers-2.min.js";
        f = document.getElementsByTagName("script")[0];
        f.parentNode.insertBefore(s, f);
      })();

    // ZenDesk script
    // (function() {
    //   let s, f;
    //   s = document.createElement("script");
    //   s.onload = () => {
    //     setTimeout(() => {
    //       (<any>window).zE("webWidget:on", "chat:connected", () => {
    //         let departments = (<any>window).zE(
    //           "webWidget:get",
    //           "chat:departments"
    //         );
    //         if (departments) {
    //           let department = departments.find(
    //             (x: any) => x.name == "Help Find Ingredient"
    //           );
    //           if (department) {
    //             (<any>window).zendeskChatStatus = department.status;
    //           }
    //         }
    //         (<any>window).zE("webWidget:on", "chat:status", (status: any) => {
    //           (<any>window).zendeskChatStatus = status;
    //           if (status != "online") {
    //             (<any>window).zE("webWidget", "close");
    //           }
    //         });
    //       });
    //     }, 1000);
    //   };
    //   s.async = true;
    //   s.id = "ze-snippet";
    //   s.src =
    //     "https://static.zdassets.com/ekr/snippet.js?key=75452247-655d-4c5c-a41f-bf3d921b9b52";
    //   f = document.getElementsByTagName("script")[0];
    //   // @ts-ignore
    //   f.parentNode.insertBefore(s, f);
    //   setTimeout(() => {
    //     (<any>window).zE("webWidget", "hide");
    //     (<any>window).zE("webWidget:on", "close", () => {
    //       (<any>window).zE("webWidget", "hide");
    //     });
    //   }, 2000);
    // })();
    })();
  },
});
